const BankAccountStatus = {
    Pending: 'PENDING',
    PendingAutomatic: 'PENDING_AUTOMATIC',
    PendingManual: 'PENDING_MANUAL',
} as const;

export default BankAccountStatus;
